export default __webpack_public_path__ + "static/media/e2-phone-bg.34a36d3e.png";